var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-skeleton-table',{class:{ 'table-skeleton': true, 'table-skeleton-lg': _vm.lg, 'table-skeleton-md': _vm.md },attrs:{"rows":_vm.rows,"columns":_vm.columns,"table-props":{ responsive: true }}})
}
var staticRenderFns = []

export { render, staticRenderFns }